import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '@/store';
import { CaseDocument } from '@/api';
import { PaginationState } from '@tanstack/react-table';

interface CaseDocumentsState {
  caseDocumentsList: CaseDocument[];
  caseDocumentsRowCount: number;
  caseDocumentsPagination: PaginationState;
}

const initialState: CaseDocumentsState = {
  caseDocumentsList: [],
  caseDocumentsRowCount: 0,
  caseDocumentsPagination: {
    pageIndex: 0,
    pageSize: 50,
  },
};

const caseDocumentsSlice = createSlice({
  name: 'caseDocuments',
  initialState: initialState,
  reducers: {
    setCaseDocumentsList: (state, action: PayloadAction<CaseDocument[]>) => {
      state.caseDocumentsList = action.payload;
    },
    updateCaseDocument: (state, action: PayloadAction<Pick<CaseDocument, 'documentId'> & Partial<CaseDocument>>) => {
      const caseDocument = state.caseDocumentsList.find(
        (document) => document.documentId === action.payload.documentId,
      );
      if (caseDocument) {
        Object.assign(caseDocument, action.payload);
      }
    },
    setCaseDocumentsRowCount: (state, action: PayloadAction<number>) => {
      state.caseDocumentsRowCount = action.payload;
    },
    setCaseDocumentsPagination: (state, action: PayloadAction<PaginationState>) => {
      state.caseDocumentsPagination = action.payload;
    },
  },
});

export const { setCaseDocumentsList, updateCaseDocument, setCaseDocumentsRowCount, setCaseDocumentsPagination } =
  caseDocumentsSlice.actions;

export const selectCaseDocumentsList = (state: RootState) => {
  return state.caseDocuments.caseDocumentsList;
};
export const selectCaseDocumentsRowCount = (state: RootState) => {
  return state.caseDocuments.caseDocumentsRowCount;
};
export const selectCaseDocumentsPagination = (state: RootState) => {
  return state.caseDocuments.caseDocumentsPagination;
};

export const caseDocumentsReducer = caseDocumentsSlice.reducer;
